const ServiceCard = ({ service }) => {
  // console.log(service);

  return (
    <div className="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm transition hover:shadow-md">


      <h3 className="mt-1 text-lg font-semibold text-gray-900">
        {service.name}
      </h3>

      <p className="mt-2 text-sm text-gray-600">
        {service.description}
      </p>

      <div className="mt-4 flex flex-wrap gap-2">
        <span className="inline-flex items-center rounded-full bg-gray-100 px-3 py-1 text-xs font-semibold text-gray-700">
          Starting from ${service.price}
        </span>

        <span className="inline-flex items-center rounded-full bg-blue-50 px-3 py-1 text-xs font-semibold text-blue-700">
          Est. {service.time_taken} mins
        </span>
      </div>

      <div className="mt-6">
        <a
          href="/book"
          className="text-sm font-semibold text-gray-900 hover:underline"
        >
          Book this service
        </a>
      </div>
    </div>
  );
};

export default ServiceCard;

